<template>
  <div class="login-geetest control">
    <transition name="lxm-transition-fade" mode="out-in">
      <div class="login-geetest__geetest-loading button is-loading"
           v-show="!captchaObjInited"></div>
    </transition>
    <transition name="lxm-transition-fade" mode="out-in">
      <div class="login-geetest__geetest"
           v-show="captchaObjInited"
           ref="geetest"></div>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  $geetest-height = 44px // geetest 高度不可设置，固定为 44px
  .login-geetest
    position: relative
    min-height: $geetest-height
    margin-right: 0 !important
    login-verify-button()
    .button
      width: 100%
      height: $geetest-height
      background-color: white
  .login-geetest__geetest-loading, .login-geetest__geetest
    position: absolute
    top: 0
    left: 0
    width: 100%
  .login-geetest__geetest
    overflow-x: hidden // geetest 最低宽度 260px 在 iphone5 下会超出 control
</style>

<script>
  import * as aTypes from '../../../store/action-types'
  // import * as mTypes from '../../../store/mutation-types'
  import { captchaObj } from '../../../store/modules/geetest'

  export default {
    data () {
      return {
        geetestAppended: false
      }
    },
    computed: {
      captchaObjInited () {
        return this.$store.state.geetest.captchaObjInited
      }
    },
    mounted () {
      this.$store.dispatch(aTypes.GEETEST_INIT)
    },
    beforeDestroy () {
      this.$store.dispatch(aTypes.GEETEST_DESTORY)
    },
    watch: {
      captchaObjInited (newVal) {
        if (newVal) {
          this.appendGeetest()
        }
      }
    },
    methods: {
      appendGeetest () {
        if (this.captchaObjInited && !this.geetestAppended) {
          this.geetestAppended = true
          captchaObj.onSuccess(() => {
            const validate = captchaObj.getValidate()
            this.$store.dispatch(aTypes.LOGIN_SUBMIT_ROBOT_VERIF_CODE, validate)
          })
          captchaObj.appendTo(this.$refs.geetest)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Geetest.vue?33063e4c